import { Theme } from '@mui/material';

export const toxLinkModalOverrides = (theme: Omit<Theme, 'components'>) => ({
  body: {
    '& .tox-dialog': {
      fontFamily: '"Noto Sans" !important',
    },

    '& .tox': {
      '& .tox-dialog__title': {
        fontFamily: '"Noto Sans"',
      },

      '& .tox-dialog__header': {
        fontFamily: '"Noto Sans"',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
      },

      '& .tox-dialog-wrap__backdrop': {
        backgroundColor: '#0000009e',
      },

      '& .tox-dialog': {
        fontFamily: '"Noto Sans"',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,

        '& .tox-dialog__body': {
          color: theme.palette.text.primary,
        },
      },

      '& .tox-form__group': {
        marginBottom: theme.spacing(1),
      },

      '& .tox-label, .tox .tox-toolbar-label': {
        fontFamily: '"Noto Sans"',
        color: theme.palette.text.primary,
        paddingBottom: theme.spacing(1),
      },

      '& .tox-listboxfield .tox-listbox--select, & .tox-textarea, & .tox-textfield, & .tox-toolbar-textfield':
        {
          fontFamily: '"Noto Sans"',
          borderColor: '#16171a',
          backgroundColor: '#16171a',
          color: theme.palette.text.primary,
          borderRadius: theme.shape.borderRadius,

          '&:focus': {
            boxShadow: 'none',
            borderColor: '#16171a',
            backgroundColor: '#16171a',
            color: theme.palette.text.primary,
            borderRadius: theme.shape.borderRadius,
          },
        },

      '& .tox-menu': {
        backgroundColor: theme.palette.background.paper,
      },

      '& .tox-collection--list': {
        fontFamily: '"Noto Sans"',
        color: `${theme.palette.text.primary} !important`,
        backgroundColor: theme.palette.background.paper,

        '& .tox-collection__item-label, & .tox-collection__item-checkmark': {
          color: theme.palette.text.primary,
        },

        '& .tox-collection__item--active': {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.light,
        },

        '& .tox-collection__item--enabled': {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
      },

      '& .tox-dialog__footer': {
        backgroundColor: theme.palette.background.paper,
      },

      '& .tox-button': {
        fontFamily: '"Noto Sans"',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,

        '&:hover': {
          borderColor: `${theme.palette.primary.dark} !important`,
          backgroundColor: `${theme.palette.primary.dark} !important`,
        },

        '&.tox-button--secondary': {
          border: `${theme.spacing(0.125)} solid ${theme.palette.error.light}`,
          backgroundColor: 'transparent',

          '&:hover, &:focus': {
            color: theme.palette.text.primary,
            backgroundColor: `${theme.palette.error.light} !important`,
            border: `${theme.spacing(0.125)} solid ${theme.palette.error.light} !important`,
          },
        },
      },

      '& .tox-dialog__header .tox-button, & .tox-dialog__header .tox-button:hover:not(:disabled)': {
        backgroundColor: `${theme.palette.background.paper} !important`,
        color: `${theme.palette.text.primary} !important`,
        borderColor: 'transparent !important',
      },
    },
  },
});
